import React from 'react'
import classNames from 'classnames'

export default class AddItemToCollectionList extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showSaved: false
    }
  }

  componentWillReceiveProps (nextProps) {
    const { item, collection } = this.props
    const currentBookmarkState = collection.bookmarks[item.id]
    const newBookmarkState = nextProps.collection.bookmarks[item.id]
    const bookmarkRemoved = currentBookmarkState && !newBookmarkState
    const bookmarkAdded = (!currentBookmarkState && newBookmarkState)
    if (bookmarkAdded || bookmarkRemoved) {
      this.setState({
        showSaved: true
      })
      setTimeout(() => {
        this.setState({
          showSaved: false
        })
      }, 500)
    }
  }

  render () {
    const { collection, item, onToggleItemInCollectionModal, index } = this.props
    const { showSaved } = this.state

    const collectionIconClassName = classNames(
      'fds-c-icon fds-u-mr1',
      collection.bookmarks[item.id] ? '-color-blue' : '-color-grey-dark',
      collection.bookmarks[item.id] ? '-icon-ok' : '-icon-plus'
    )
    const collectionItemStyle = {
      background: collection.bookmarks[item.id] ? '#e5f2f7' : '#fff',
      padding: '8px 16px',
      marginTop: index === 0 ? '8px' : '0px',
      marginBottom: '8px',
      fontSize: '14px'
    }
    const collectionItemLinkStyle = {
      display: 'block'
    }
    const flashMessageStyle = {
      position: 'absolute',
      right: '20px',
      color: '#0084b4'
    }

    return (
      <li
        className='fds-c-text-body'
        style={collectionItemStyle}
      >
        <a
          href={`/collections/${collection.id}/bookmarks?item_id=${item.id}`}
          onClick={(event) => onToggleItemInCollectionModal(event, collection, item)}
          className='fds-c-text-link -color-dark -weight-bold -decoration-none'
          style={collectionItemLinkStyle}
          rel='nofollow'
          title={`Add to Collection ${collection.name}`}
        >
          <i className={collectionIconClassName} /> {collection.name}
          {showSaved &&
            <span style={flashMessageStyle}>saved</span>
          }
        </a>
      </li>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/modals/collection/addItemToCollectionList.js